module.exports = __webpack_public_path__ + "img/user.b0c97cea.png";